import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { Button, SelectDropdown, TextAreaInput } from "../../shared/inputs";
import { Modal } from "react-bootstrap";
//import Profile from "../../shared/profile/Profile";
import { NetworkAxios, OnboardingAxios, UserActivityAxios } from "../../API";
import authSlice from "../../store/auth/authSlice";
import CouponItem from "./CouponItem";

export default function Coupons() {
  const userDetails = useSelector((state) => state.auth.loggedInUser);
  //const [showProfile, setShowProfile] = useState(false);
  const [showCoupons, setShowCoupons] = useState(false);
  const [selectedCoupon, setSelectedCoupon] = useState(0);
  const [usedCoupon, setUsedCoupon] = useState(1);
  const [coupons, setCoupons] = useState([]);
  const [myConnections, setMyConnections] = useState([]);
  const [connectionOptions, setConnectionOptions] = useState([]);
  const [selectedConnection, setSelectedConnection] = useState("");
  const [couponBrief, setCouponBrief] = useState();
  const currentStageId = useSelector((state) => state.appState.currentStage) || userDetails.currentStageId;
  const journeyMap = useSelector((state) => state.journeyMapSlice.journeyMap);
  const [couponBriefLabel, setCouponBriefLabel] = useState("Who eﬀectively manages relationships with leads and teams to deliver excellent results …");

  const couponBriefLabels = {
    Connect: "Who eﬀectively manages relationships with leads and teams to deliver excellent results …",
    Own: "Who drives work forward and demonstrates ownership in a ﬂuid, rapidly changing environment …",
    Solve: "Who frames and analyzes problems and identiﬁes solutions in collaboration with the team …",
    Communicate: "Who articulates messages clearly and intentionally, adapting for diﬀerent audiences …"
  };

  let messagePoint = { ...useSelector((state) => state.auth.messagePoint) };
  // messagePoint.activityId = indivisualActivityId;

  useEffect(() => {
    getCouponAndConnections();
  }, [showCoupons]);

  useEffect(() => {
    let connectionOption =
      myConnections.length > 0 &&
      myConnections
        // .filter((item) => item.roleId !== 5)
        .map((item) => {
          return {
            label: item.firstName + " " + item.lastName,
            value: item.offeringUserId,
            teamName: item.teamName
          };
        });

    setConnectionOptions(connectionOption);
    // if (connectionOption.length > 0)
    //   setSelectedConnection(connectionOption[0].value);
  }, [myConnections]);

  const getCouponAndConnections = () => {
    let localStageId = 0;
    if (currentStageId == 0) {
      if (journeyMap.length > 0) {
        localStageId = journeyMap[journeyMap.length - 1]["stageId"];
      }
    }
    else {
      localStageId = currentStageId;
    }

    OnboardingAxios.get(
      "OfferingUserCoupon/getcoupons/" +
      userDetails.offeringUserId +
      "/" +
      localStageId
    ).then((res) => {
      let data = res.data;
      if (data) {
        let remainCoupon = data.filter((item) => item.isAvailable);
        let usedCoupon = data.filter((item) => !item.isAvailable);
        setUsedCoupon(usedCoupon.length);
        if (remainCoupon.length > 0) {
          setSelectedCoupon(remainCoupon[0].id);
        }
        //sort by sequence
        data.sort((a, b) => {
          return a.sequence - b.sequence;
        });
        setCoupons(data);
      }
    });

    NetworkAxios.get(
      "Connection/getmyconnections/" + userDetails.offeringUserId
    )
      .then(function (response) {
        let data = response ? response.data : [];
        setMyConnections(data);
      })
      .catch(function (error) { });
  };

  // const openProfile = () => {
  //   dispatch(authSlice.actions.setProfileData({ userId: userDetails.userId }));
  //   dispatch(authSlice.actions.showProfile({ scrollToCoupon: true }));
  // };

  const sendCoupon = (e) => {
    e.preventDefault();
    const couponData = {
      couponId: selectedCoupon,
      awardedTo: selectedConnection,
      notes: couponBrief,
    };

    var requestData = {
      requestModel: couponData,
      message: messagePoint,
      isBackgroundJob: false
    };

    OnboardingAxios.put("OfferingUserCoupon/award", requestData).then((res) => {
      getCouponAndConnections();
      setCouponBrief("");

      //send notification
      var notificationData = [
        {
          offeringId: userDetails.offeringId,
          missionId: userDetails.missionId,
          activityBy: userDetails.offeringUserId,
          offeringUserId: selectedConnection,
          teamId: 0,
          notificationText: `sent you a token`,
          actionRoute: JSON.stringify({
            action: "gave-coupon",
            actionText: "View",
            offeringUserId: userDetails.offeringUserId,
          }),
        },
      ];

      var requestObject = {
        requestModel: notificationData,
        message: messagePoint,
        isBackgroundJob: false
      };
      UserActivityAxios.post("Notification/sendnotifications", requestObject)
        .catch(function (er) {
          console.log(er);
        });
      //end send notification
    });
  };

  useEffect(() => {
    console.log("SelectedCoupon", selectedCoupon);
    if (coupons.length > 0 && selectedCoupon > 0) {
      let cpnName = coupons.find((item) => item.id == selectedCoupon);
      if (cpnName) {
        setCouponBriefLabel(couponBriefLabels[cpnName.couponName]);
      }
    }
  }, [selectedCoupon, coupons]);

  return (
    <>
      <div className="coupon-card">
        <div className="coupons-main">
          <div className="coupon-details">
            <div className="coupons-icon"></div>
            <div className="coupons-info">
              <h5 className="coupons-title">Tokens</h5>
              <div className="coupons-text">
                Use Tokens to send appreciation notes to your coach and peers.
              </div>
            </div>
          </div>
          <div className="coupon-action">
            <Button className="" onClick={() => setShowCoupons(true)}>
              Send
            </Button>
            {/* <Button className="" onClick={() => openProfile()}>Received</Button> */}
          </div>
        </div>
      </div>
      <Modal
        show={showCoupons}
        onHide={() => setShowCoupons(false)}
        dialogClassName="coupons-modal modal-90w"
        aria-labelledby="coupons-modal"
        centered
      >
        <Modal.Body>
          <Button
            className="nav-btn close"
            onClick={() => setShowCoupons(false)}
          />

          <div className="coupons-dialog-wrapper">
            <div className="border-glow"></div>
            <div className="coupons-list-wrapper">
              <h4 className="coupon-title">TOKENS</h4>
              <div className="coupons-list">
                {coupons.map((item) => {
                  return (
                    <CouponItem
                      {...item}
                      selectedCoupon={selectedCoupon}
                      setSelectedCoupon={setSelectedCoupon}
                      key={"coupon-" + item.id}
                    />
                  );
                })}
              </div>
            </div>
            <div className="vertical-devider m-0"></div>
            <div className="coupons-user-info">
              {usedCoupon < 4 ? (
                <>
                  <form onSubmit={(e) => sendCoupon(e)}>
                    <SelectDropdown
                      placeholder="Select Your Connection"
                      label="I’d like to provide a token of my appreciation to"
                      className="coupon-input"
                      value={selectedConnection}
                      onChange={(v) => setSelectedConnection(v.target.value)}
                      options={connectionOptions}
                      required
                    />

                    <TextAreaInput
                      label={couponBriefLabel}
                      className="coupon-input"
                      rows="4"
                      value={couponBrief}
                      maxLength="200"
                      onChange={(item) => setCouponBrief(item.target.value)}
                    />
                    <Button
                      className="button-margin"
                      disabled={!couponBrief}
                      type="submit"
                    >
                      Send
                    </Button>
                  </form>
                </>
              ) : (
                <>
                  <div className="coupon-note">
                    <span>
                      You have awarded all coupons available in this stage. You
                      will be able to award additional coupons when you move to
                      the next stage in your journey.
                    </span>
                  </div>
                </>
              )}
            </div>
            <div className="border-glow-bottom"></div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}
